module.exports = __webpack_public_path__ + "static/media/12UNCTAD4.f446da78.jpg";